module.exports = __webpack_public_path__ + "static/media/hourglass-start.ad83df5a.svg";